import { useState } from "react";
import { Badge, Button, Card, CardBody, CardHeader, Table } from "reactstrap";
import { EditShippingAddressModal } from "./EditShippingAddressModal";

const formatEditDate = (value) =>
  value ? new Date(value).toLocaleString("es-CO", { dateStyle: "medium", timeStyle: "short" }) : "-";

/** "Calle 1 # 2-3 · Medellín, Antioquia" a partir de un snapshot. */
const summarize = (a) =>
  a ? [a.address, [a.city?.name, a.province?.name].filter(Boolean).join(", ")].filter(Boolean).join(" · ") : "-";

export const CardShippingOrder = ({ order, onUpdated }) => {
  const isLocal = order?.delivery_type !== "DELIVERY";
  const [editOpen, setEditOpen] = useState(false);
  const edits = order?.shipping_address_edits || [];

  const hasSnapshot = !!order?.shipping_address;

  const s = hasSnapshot
    ? order.shipping_address
    : order.address_id;

  const country = hasSnapshot
    ? s?.country?.name
    : s?.country_id?.name;

  const department = hasSnapshot
    ? s?.province?.name
    : s?.province_id?.name;

  const city = hasSnapshot
    ? s?.city?.name
    : s?.city_id?.name;

  const address = s?.address;
  const name = s?.name;
  const postalCode = s?.postal_code;
  const observations = s?.observations;
  const tracking = order?.shipping?.tracking;
  const receiver = s?.receiver;

  return (
    <Card className="shadow-sm">
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0">
          Datos de envío
          {edits.length > 0 && (
            <Badge color="warning" className="ms-2" style={{ color: "#fff" }}>
              Dirección editada
            </Badge>
          )}
        </h5>
        {!isLocal && (
          <Button color="primary" outline size="sm" onClick={() => setEditOpen(true)}>
            <i className="fa fa-pencil me-1" />
            Editar dirección
          </Button>
        )}
      </CardHeader>

      {editOpen && (
        <EditShippingAddressModal
          order={order}
          isOpen={editOpen}
          toggle={() => setEditOpen(false)}
          onDone={onUpdated}
        />
      )}

      <CardBody>
        {isLocal ? (
          <p className="text-muted mb-0">
            El usuario recogerá el pedido localmente.
          </p>
        ) : (
          <Table borderless responsive>
            <tbody>
              {tracking && (
                <tr>
                  <th>Número de guía de envío</th>
                  <td>{tracking}</td>
                </tr>
              )}

              <tr>
                <th>País</th>
                <td>{country || "-"}</td>
              </tr>

              <tr>
                <th>Departamento</th>
                <td>{department || "-"}</td>
              </tr>

              <tr>
                <th>Ciudad</th>
                <td>{city || "-"}</td>
              </tr>

              <tr>
                <th>Nombre</th>
                <td>{name}</td>
              </tr>
              <tr>
                <th>Dirección</th>
                <td>{address || "-"}</td>
              </tr>
              <tr>
                <th>Barrio / Corregimiento</th>
                <td>{s?.neighborhood || "No aplica"}</td>
              </tr>

              <tr>
                <th>Recibe el pedido</th>
                <td>
                  {receiver?.type === "other"
                    ? "Otra persona"
                    : "Titular"}
                </td>
              </tr>

              {receiver?.type === "other" && (
                <>
                  {receiver?.name && (
                    <tr>
                      <th>Nombre receptor</th>
                      <td>{receiver.name}</td>
                    </tr>
                  )}

                  {receiver?.document && (
                    <tr>
                      <th>Documento receptor</th>
                      <td>{receiver.document}</td>
                    </tr>
                  )}

                  {receiver?.phone && (
                    <tr>
                      <th>Teléfono receptor</th>
                      <td>{receiver.phone}</td>
                    </tr>
                  )}
                </>
              )}

              <tr>
                <th>Código postal</th>
                <td>{postalCode || "-"}</td>
              </tr>

              <tr>
                <th>Observaciones</th>
                <td>{observations || "-"}</td>
              </tr>

              {order?.dropi && (
                <>
                  <tr>
                    <th>Transportadora</th>
                    <td>{order.dropi.company}</td>
                  </tr>

                  <tr>
                    <th>Número de guía</th>
                    <td>{order.dropi.shipping_guide}</td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
        )}

        {edits.length > 0 && (
          <div className="mt-3">
            <h6 className="fw-bold">Historial de cambios de dirección</h6>
            {[...edits].reverse().map((edit, index) => (
              <div key={index} className="border-top pt-2 mt-2" style={{ fontSize: 12 }}>
                <div>
                  <strong>{formatEditDate(edit.edited_at)}</strong>
                  {edit.edited_by?.name && ` · por ${edit.edited_by.name}`}
                </div>
                <div className="text-muted">Antes: {summarize(edit.previous)}</div>
              </div>
            ))}
          </div>
        )}
      </CardBody>
    </Card>
  );
};